<script>
  /* Copyright (c) 2020 Jacques Desodt */
  export let args = null
  /* Local variables */
  const style = args.bgColor ? 'background-color:' + args.bgColor + ';' : ''
</script>

<div class="_tp-center" {style} />

<style>
  ._tp-center {
    top: 50%;
    left: 50%;
    width: 6px;
    height: 6px;
    position: absolute;
    transform: translate(-50%, -50%);
    border-radius: 50%;
  }
</style>
